import React, { useEffect, useState } from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import './WordlistLoadingAnimation.css'; // for animation styling

const NUM_ITEMS = 6;

const WORDS = [
  "PETAL;43", "BLOSSOM;67", "ROSE;88", "LILY;22", "DAISY;45", "TULIP;39", "ORCHID;60", "PEONY;77", "MARIGOLD;12",
  "IRIS;56", "LAVENDER;74", "POPPY;18", "DAFFODIL;85", "CARNATION;63", "CHRYSANTHEMUM;40", "HYACINTH;27",
  "ZINNIA;58", "ASTER;36", "HIBISCUS;71", "CAMELLIA;49", "BLUEBELL;31", "BEGONIA;80", "AMARYLLIS;13", "SNAPDRAGON;44",
  "GERANIUM;26", "PRIMROSE;66", "FOXGLOVE;19", "COSMOS;59", "SUNFLOWER;33", "GARDENIA;87", "AZALEA;21",
  "FREESIA;41", "CALENDULA;79", "DELPHINIUM;32", "ANEMONE;54", "VERBENA;17", "WISTERIA;62", "LILAC;48",
  "CROCUS;37", "BUTTERCUP;51", "YARROW;76", "SWEETPEA;25", "NASTURTIUM;46", "BELLFLOWER;70", "TANSY;28",
  "PETUNIA;65", "PHLOX;11", "HELIOTROPE;42", "BOUVARDIA;73", "CLOVER;38", "SCABIOSA;52", "STOCK;14", "NEMESIA;83",
  "GAILLARDIA;30", "SALVIA;69", "LOBELIA;34", "COLUMBINE;57", "STATICE;20", "COREOPSIS;64", "FORGETMENOT;81",
  "RANUNCULUS;29", "CONEFLOWER;47", "SWEETWILLIAM;50", "NIGELLA;16", "AGERATUM;68", "ALLIUM;35", "GLADIOLUS;75",
  "ALSTROEMERIA;15", "CELANDINE;53", "PANSY;24", "TUBEROSE;61", "HELLEBORE;78", "CAMOMILE;23", "CELOSIA;66",
  "HOLLYHOCK;36", "LARKSPUR;55", "WALLFLOWER;84", "LANTANA;13", "BALSAM;60", "DIANTHUS;43", "MIMOSA;72",
  "FLAX;19", "VERBASCUM;67", "RUE;12", "SAGE;71", "COWSLIP;40", "CATCHFLY;20", "JACOBSLADDER;74", "HEATHER;59",
  "BLOODROOT;33", "LOOSESTRIFE;39", "MILKWORT;45", "BEEBALM;30", "SPEEDWELL;88", "SORREL;49", "BONESET;35",
  "CHICORY;22", "FIREWEED;77", "THISTLE;18", "GOLDENROD;62", "MALLOW;27", "SKULLCAP;85", "TOADFLAX;31", "YARROWLEAF;69"
];

function getRandomStyledWord() {
  const raw = WORDS[Math.floor(Math.random() * WORDS.length)];
  const [word, score] = raw.split(';');

  const chance = Math.random();
  if (chance < 0.5) {
    return { text: `+${word};${score}`, className: 'green-word' };
  } else if (chance < 0.6) {
    return { text: `${word};${score}`, className: 'red-word' };
  } else {
    return { text: `${word};${score}`, className: '' };
  }
}

export default function WordlistLoadingAnimation() {
  const [words, setWords] = useState(Array.from({ length: NUM_ITEMS }, () => getRandomStyledWord()));

  useEffect(() => {
    const interval = setInterval(() => {
      setWords(prev => {
        const newWords = [...prev];
        const idx = Math.floor(Math.random() * NUM_ITEMS);
        newWords[idx] = { ...getRandomStyledWord(), key: Math.random() }; // change key to force re-render
        return newWords;
      });
    }, 300);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="d-flex flex-column gap-4">
      <Card className="block-text" style={{ width: '15rem', fontSize: '16px' }}>
        <Card.Header className="fw-bold text-center p-2">Loading Wordlists...</Card.Header>
        <ListGroup
          className='p-2'
          variant="flush"
          style={{
            fontSize: '14px',
            fontWeight: 'bold',
            maxHeight: '200px',
            overflow: 'hidden',
            position: 'relative'
          }}
        >
          {words.map((w, i) => (
            <ListGroup.Item
              key={w.key || i}
              className={`p-0 fade-in ${w.className}`}
            >
              {w.text}
            </ListGroup.Item>
          ))}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(to bottom, transparent, white)'
            }}
          />
        </ListGroup>
      </Card>
    </div>
  );
}
